import * as React from "react";
import {
  Box,
  FormControl,
  Button,
  Divider,
  Typography,
  Popover,
  Stack,
  TextField as MUITextField
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useStoreActions } from "easy-peasy";
import api from "../../../services/api";
import {
  TextField,
  IntegerField,
  Autocomplete,
  FloatField } from "../../../components";
import yupnanable from '../../../services/yup-nanable.js';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Registros = ({ ano, empresa }) => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [produtos, setProdutos] = React.useState([]);

  const [firstPopoverAnchor, setFirstPopoverAnchor] = React.useState(null);
  const [secondPopoverAnchor, setSecondPopoverAnchor] = React.useState(null);
  const [thirdPopoverAnchor, setThirdPopoverAnchor] = React.useState(null);
  const [fourthPopoverAnchor, setFourthPopoverAnchor] = React.useState(null);
  const [fifthPopoverAnchor, setFifthPopoverAnchor] = React.useState(null);

  const handleFirstClick = (event) => {
    setFirstPopoverAnchor(event.currentTarget);
  };

  const handleSecondClick = (event) => {
    setSecondPopoverAnchor(event.currentTarget);
  };

  const handleThirdClick = (event) => {
    setThirdPopoverAnchor(event.currentTarget);
  };

  const handleFourthClick = (event) => {
    setFourthPopoverAnchor(event.currentTarget);
  };
  const handleFifthClick = (event) => {
    setFifthPopoverAnchor(event.currentTarget);
  };

  const handleCloseFirstClick = (event) => {
    setFirstPopoverAnchor(null);
  };

  const handleCloseSecondClick = (event) => {
    setSecondPopoverAnchor(null);
  };

  const handleCloseThirdClick = (event) => {
    setThirdPopoverAnchor(null);
  };

  const handleCloseFourthClick = (event) => {
    setFourthPopoverAnchor(null);
  };
  const handleCloseFifthClick = (event) => {
    setFifthPopoverAnchor(null);
  };

  const schema = yup.object({
    produtoId: yup.number().positive().nullable().nanable()
      .label("Produto"),
    producaoTotal: yup.number().integer().nullable().nanable()
      .label("Produção (ton)"),
    totalReciclados: yup.number().integer().nullable().nanable()
      .label("Reciclagem/Reuso/etc (ton)"),
    totalOutroDest: yup.number().integer().nullable().nanable()
      .label("Outros destinos (ton)"),
    geracaoRejeitos: yup.number().integer().nullable().nanable()
      .label("Rejeitos (ton)"),
    geracaoEsteril: yup.number().integer().nullable().nanable()
      .label("Estéril (ton)"),
    investEconoCircul: yup.number().nullable().float().nanable()
      .label("Investimento circular (R$)"),
    metalurConsumCirc: yup.number().integer().nullable().nanable()
      .label("Minero-metalúrgico (ton)"),
    observacoes: yup.string().nullable()
      .max(1000, 'Máximo 1000 caracteres')
      .label(
        "Deixe seu comentário ou outras informações que considerar importante"
      ),
  }).required();

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
  });

  const {
    handleSubmit,
    reset,
    watch,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const loadRegistros = async (mount) => {
    startLoading();
    try {
      let url = "12/registros/empresa/" + empresa + "/" + ano;
      let getRegistros = await api.http.get(url);
      if (mount.isMounted) {
        reset(getRegistros.data)
      }
      stopLoading();
    } catch (error) {
      if (error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            produtoId: null,
            producaoTotal: '',
            totalReciclados: '',
            totalOutroDest: '',
            geracaoRejeitos: '',
            geracaoEsteril: '',
            investEconoCircul: '',
            metalurConsumCirc: '',
            observacoes: null,
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
      }
    }
  };
  const loadProdutos = async (mount) => {
    startLoading();
    try {
      let data = ((await api.http.get('produtos')).data);
      if (mount.isMounted)
        setProdutos(data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const submit = async (data) => {
    startLoading();
    try {
      let result;
      if (data.id) {
        result = await api.http.put(
          "12/registros/empresa/" + empresa + "/" + data.id,
          { ...data }
        );
      } else {
        result = await api.http.post("12/registros/empresa/" + empresa, {
          ...data,
          ano: ano,
        });
      }
      reset(result.data);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true,
    };
    loadProdutos(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    let mount = {
      isMounted: true,
    };
    loadRegistros(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, empresa]);

  const totalReciclados = watch('totalReciclados');
  const totalOutroDest = watch('totalOutroDest');
  const [geracaoTotal, setGeracaoTotal] = React.useState(0);

  React.useEffect(() => {
    const result = Number(totalReciclados) + Number(totalOutroDest);
    setGeracaoTotal(result);
  }, [totalReciclados,totalOutroDest]);


  return (
    (<div>
      <Grid container spacing={2} sx={{
        alignItems: 'center',
        '& .MuiTypography-root': { textAlign: 'right' },
        '& .MuiGrid-root': { p: 1 },
      }}>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>
            Qual o principal produto (tipo de minério)produzido pela sua
            empresa?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <Autocomplete

              field="produtoId"
              useFormRef={useFormRef}
              options={produtos}
              getOptionLabel={(value) => value.name}
              schema={schema}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>Qual a produção total de bem mineral?</Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="producaoTotal"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Stack direction="row" justifyContent={'end'} alignItems={'center'}>
            <Typography>
              Qual a quantidade total de resíduos não minerais destinado para
              reciclagem, reprocessamento, reuso, etc.?
            </Typography>
            <HelpOutlineIcon
              onClick={handleFifthClick}
              sx={{
                m: 2,
              }}
            />
          </Stack>
          <Popover
            open={Boolean(fifthPopoverAnchor)}
            anchorEl={fifthPopoverAnchor}
            onClose={handleCloseFifthClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Total de volume de resíduos não minerais gerados.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="totalReciclados"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>
            Qual a quantidade total de outras destinações para os resíduos não
            minerais (aterros, incineração, disposição)?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="totalOutroDest"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Stack direction="row" justifyContent={'end'} alignItems={'center'}>
            <Typography>
              Geração total de resíduos não minerais
            </Typography>
            <HelpOutlineIcon
              onClick={handleFirstClick}
              sx={{
                m: 2,
              }}
            />
          </Stack>
          <Popover
            open={Boolean(firstPopoverAnchor)}
            anchorEl={firstPopoverAnchor}
            onClose={handleCloseFirstClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Total de volume de resíduos não minerais gerados.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <MUITextField
              label="Geração resíduos não minerais (ton)"
              type="number"
              disabled={true}
              value={geracaoTotal?geracaoTotal:0}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Stack direction="row" justifyContent={'end'} alignItems={'center'}>
            <Typography>
              Qual a geração de rejeitos da mineração?
            </Typography>
            <HelpOutlineIcon
              onClick={handleSecondClick}
              sx={{
                m: 2,
              }}
            />
          </Stack>
          <Popover
            open={Boolean(secondPopoverAnchor)}
            anchorEl={secondPopoverAnchor}
            onClose={handleCloseSecondClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Rejeito: material descartado durante e/ou após o processo de beneficiamento.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="geracaoRejeitos"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Stack direction="row" justifyContent={'end'} alignItems={'center'}>
            <Typography>
              Qual a geração de estéril?
            </Typography>
            <HelpOutlineIcon
              onClick={handleThirdClick}
              sx={{
                m: 2,
              }}
            />
          </Stack>
          <Popover
            open={Boolean(thirdPopoverAnchor)}
            anchorEl={thirdPopoverAnchor}
            onClose={handleCloseThirdClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Estéril: material in natura descartado diretamente na operação de lavra, antes do beneficiamento.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="geracaoEsteril"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Stack direction="row" justifyContent={'end'} alignItems={'center'}>
            <Typography>
              Qual o valor do investimento em iniciativas de economia circular
              (P&D, desenvolvimento de tecnologias, estudos, implantação de
              projetos, etc.)?
            </Typography>
            <HelpOutlineIcon
              onClick={handleFourthClick}
              sx={{
                m: 2,
              }}
            />
          </Stack>
          <Popover
            open={Boolean(fourthPopoverAnchor)}
            anchorEl={fourthPopoverAnchor}
            onClose={handleCloseFourthClick}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2 }}>
              Investimento em P&D, desenvolvimento de tecnologias, estudos, implantação de projetos, eficiência na geração de resíduos, etc.
            </Typography>
          </Popover>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <FloatField
              field="investEconoCircul"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
        <Grid
          size={{
            md: 8
          }}>
          <Typography>
            Qual a quantidade de material minero-metalúrgico consumido em
            praticas circulares?
          </Typography>
        </Grid>
        <Grid
          size={{
            md: 4
          }}>
          <FormControl fullWidth>
            <IntegerField
              field="metalurConsumCirc"
              schema={schema}
              useFormRef={useFormRef}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 3 }}>
        <h3>Observações</h3>
      </Divider>
      <FormControl fullWidth>
        <TextField
          field="observacoes"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Box sx={{mt:3}}>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(submit)}
          disabled={!isDirty || isSubmitting}
        >
          SALVAR
        </Button>
      </Box>
    </div>)
  );
};

export default Registros;
